import { AUTH_API, handleApiError } from '../../utils/axios';

export const getUsers = async (search) => {
  try {
    const { data } = await AUTH_API.get(
      `/api/v1/users?page=${search.page}&size=${search.size}&search=${search.search}`,
    );
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createUser = async (user) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/users`, user);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateUser = async (user) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/users/${user.id}`, user);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deactivateUser = async (user) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/users/${user.id}/deactivate`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const activateUser = async (user) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/users/${user.id}/activate`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
